export var TaxReliefElegibleType;
(function (TaxReliefElegibleType) {
    TaxReliefElegibleType["Yes"] = "YES";
    TaxReliefElegibleType["No"] = "NO";
    TaxReliefElegibleType["Partial"] = "PARTIAL";
})(TaxReliefElegibleType || (TaxReliefElegibleType = {}));
export var ConsiderationType;
(function (ConsiderationType) {
    ConsiderationType["Cash"] = "CASH";
    ConsiderationType["Share"] = "SHARE";
})(ConsiderationType || (ConsiderationType = {}));
export var ShareConsiderationAllocationMethod;
(function (ShareConsiderationAllocationMethod) {
    ShareConsiderationAllocationMethod["Upload"] = "UPLOAD";
    ShareConsiderationAllocationMethod["Automatic"] = "AUTOMATIC";
})(ShareConsiderationAllocationMethod || (ShareConsiderationAllocationMethod = {}));
export var BuildingPdfStatus;
(function (BuildingPdfStatus) {
    BuildingPdfStatus["NOT_STARTED"] = "notStarted";
    BuildingPdfStatus["COMPLETE"] = "complete";
    BuildingPdfStatus["PROCESSING"] = "processing";
    BuildingPdfStatus["FAILURE"] = "failure";
})(BuildingPdfStatus || (BuildingPdfStatus = {}));
export var ExitStatementStatus;
(function (ExitStatementStatus) {
    ExitStatementStatus["Draft"] = "DRAFT";
    ExitStatementStatus["Submitted"] = "SUBMITTED";
})(ExitStatementStatus || (ExitStatementStatus = {}));
export var ExitStatementNotificationType;
(function (ExitStatementNotificationType) {
    ExitStatementNotificationType["Exit"] = "exit";
    ExitStatementNotificationType["Loss"] = "loss";
})(ExitStatementNotificationType || (ExitStatementNotificationType = {}));
export var ConsiderationHistoryItemType;
(function (ConsiderationHistoryItemType) {
    ConsiderationHistoryItemType["ShareConsiderationExit"] = "shareConsiderationExit";
    ConsiderationHistoryItemType["CashExit"] = "cashExit";
})(ConsiderationHistoryItemType || (ConsiderationHistoryItemType = {}));
//# sourceMappingURL=index.js.map